import React from "react";

import {
  ModalOverlay,
  Wrapper,
  Modal,
  Card,
  CardBody,
  Title,
  Copy,
  Bold,
  PrimaryButton,
  SecondaryButton
} from "app/NativeComponents/common";

import { TextButton } from "app/NativeComponents/snippets";

import { callPhoneNumber, textPhoneNumber } from "app/NativeActions";
const renderCallButton = props => {
  if (
    props.device == "mobile" &&
    props.selected_to_number.blocked != 1 &&
    props.selected_to_number.do_not_call != 1 &&
    props.selected_to_number.landline != 1
  ) {
    return (
      <Card style={{ borderRadius: 30, overflow: "hidden" }}>
        <SecondaryButton
          onPress={() => {
            callPhoneNumber(props.selected_to_number.phone_number);
            props.toggleMore(false);
          }}
        >
          Call {props.selected_to_number.phone_number}
        </SecondaryButton>
      </Card>
    );
  }
};

const renderSendAllButton = props => {
  if (props.lead_to_phone_numbers && props.lead_to_phone_numbers.length > 1) {
    return (
      <Card style={{ borderRadius: 30, overflow: "hidden" }}>
        <SecondaryButton
          onPress={() => {
            props.setMultisendFilters({
              lead_ids: props.active_property.deal.id,
              filters: {},
              filter_lists: [],
              onSuccess: () => {
                props.appRedirect({
                  redirect: "goForward",
                  payload: {
                    add: "send-text-messages"
                  }
                });
                props.toggleMore(false);
              }
            });
          }}
        >
          Message All Numbers
        </SecondaryButton>
      </Card>
    );
  }
};

const renderMarkAsBadButton = props => {
  if (
    props.selected_to_number.phone_number &&
    props.selected_to_number.blocked != 1 &&
    props.selected_to_number.do_not_call != 1 &&
    props.selected_to_number.bad_phone != 1
  ) {
    return (
      <Card style={{ borderRadius: 30, overflow: "hidden" }}>
        <SecondaryButton
          onPress={() => {
            props.updateOwnerInfo({
              token: props.token,
              deal_id: props.active_property.deal.id,
              owner_phone_number_id:
                props.selected_to_number.owner_phone_number_id,
              type: "edit_phone_number",
              phone_label: props.selected_to_number.phone_label,
              phone_number: props.selected_to_number.phone_number,
              bad_phone: 1,
              onSuccess: () => {}
            });
            props.toggleMore(false);
          }}
        >
          Mark Number As "Wrong"
        </SecondaryButton>
      </Card>
    );
  }
};

const renderDoNotCallButton = props => {
  if (
    props.selected_to_number.phone_number &&
    props.selected_to_number.do_not_call != 1
  ) {
    return (
      <Card style={{ borderRadius: 30, overflow: "hidden" }}>
        <SecondaryButton
          onPress={() => {
            props.setModal({
              title: 'Report to "Do Not Call" list?',
              description:
                'Are you sure you want to report and add this phone number to the "Do Not Call" list?',
              icon: "",
              submit: "Report Phone Number",
              buttonType: "destroy",
              onPress: () => {
                props.updateOwnerInfo({
                  token: props.token,
                  deal_id: props.active_property.deal.id,
                  owner_phone_number_id:
                    props.selected_to_number.owner_phone_number_id,
                  type: "master_do_not_call_list",
                  phone_number: props.selected_to_number.phone_number,
                  onSuccess: () => {}
                });
                props.toggleMore(false);
              },
              cancel: "Cancel",
              onCancel: () => {}
            });
            props.toggleModal({ show: true, type: "normal" });
            props.toggleMore(false);
          }}
        >
          Report To "Do Not Call" List
        </SecondaryButton>
      </Card>
    );
  }
};

const renderEditButton = props => {
  if (
    props.selected_to_number.phone_number &&
    props.selected_to_number.blocked != 1 &&
    props.selected_to_number.do_not_call != 1
  ) {
    return (
      <Card style={{ borderRadius: 30, overflow: "hidden" }}>
        <SecondaryButton
          onPress={() => {
            props.setEditModal({
              title: "Edit Phone Number",
              description: "Edit phone number",
              slug: "edit-owner-phone-number",
              type: "edit_owner_phone_number",
              fields: {
                manual_number: parseInt(props.selected_to_number.manual),
                bad_phone: parseInt(props.selected_to_number.bad_phone),
                phone_label: props.selected_to_number.phone_label,
                phone_number: props.selected_to_number.phone_number
              },
              save_button_text: "Edit",
              modalAction: ({ fields }) => {
                props.updateOwnerInfo({
                  token: props.token,
                  deal_id: props.active_property.deal.id,
                  owner_phone_number_id:
                    props.selected_to_number.owner_phone_number_id,
                  type: "edit_phone_number",
                  phone_label: fields.phone_label,
                  phone_number: fields.phone_number,
                  bad_phone: fields.bad_phone,
                  onSuccess: () => {}
                });
              },
              cancelAction: () => {},
              can_remove: false
            });
            props.appRedirect({
              redirect: "goForward",
              payload: { add: "edit-owner-phone-number" }
            });

            props.toggleMore(false);
          }}
        >
          Edit Phone Number
        </SecondaryButton>
      </Card>
    );
  }
};

const PhoneNumberMore = props => {
  if (props.phone_number_more === true && props.selected_to_number) {
    return (
      <ModalOverlay isVisible={true} onPress={() => props.toggleMore(false)}>
        <Modal actionSheet>
          <Card
            style={{
              minWidth: "95%",
              paddingBottom: props.device == "mobile" ? 10 : 0
            }}
          >
            <CardBody>
              <Title style={{ textAlign: "center" }}>Message Options</Title>
              <Copy style={{ textAlign: "center" }}>Select an option</Copy>
            </CardBody>
            {renderSendAllButton(props)}
            {renderCallButton(props)}
            {renderMarkAsBadButton(props)}
            {renderDoNotCallButton(props)}
            {renderEditButton(props)}

            <Card style={{ borderRadius: 30, overflow: "hidden" }}>
              <SecondaryButton
                onPress={() => {
                  props.setModal({
                    title: "Remove phone number?",
                    description:
                      "Are you sure you want to remove this phone number? This will also remove your conversations.",
                    icon: "",
                    submit: "Remove",
                    buttonType: "destroy",
                    onPress: () => {
                      props.updateOwnerInfo({
                        token: props.token,
                        deal_id: props.active_property.deal.id,
                        owner_phone_number_id:
                          props.selected_to_number.owner_phone_number_id,
                        type: "remove_phone_number"
                      });
                    },
                    cancel: "Cancel",
                    onCancel: () => {}
                  });
                  props.toggleModal({ show: true, type: "normal" });

                  props.toggleMore(false);
                }}
              >
                Remove Phone Number
              </SecondaryButton>
            </Card>

            <TextButton
              onPress={() => props.toggleMore(false)}
              text={"Cancel"}
            />
          </Card>
        </Modal>
      </ModalOverlay>
    );
  }

  return <Wrapper />;
};

export default PhoneNumberMore;
